import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popper, ClickAwayListener } from '@material-ui/core';
import classNames from 'classnames';
import _ from 'lodash';

import './DropDown.scss';

class DropDown extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', !_.isUndefined(this.props.closeMenu) ? this.props.closeMenu : this.handleClose);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', !_.isUndefined(this.props.closeMenu) ? this.props.closeMenu : this.handleClose);
  }

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  handleClose = (e) => {
    // Prevents clickAway from triggering when clicking the button
    if (this.anchorEl && this.anchorEl.contains(e.target)) {
      return;
    }

    if (this.state.open) {
      this.setState({ open: false });
    }
  };

  render() {
    const {
      className,
      children,
      value,
      IconComponent,
      popperClass,
      iconMargin,
      placement,
      openMenu,
      closeMenu,
      open,
      isRetail
    } = this.props;
    const Component = () => <>{ IconComponent }</>;
    const openStatus = !_.isUndefined(open) ? open : this.state.open;
    const openFunc = !_.isUndefined(openMenu) ? openMenu : this.handleClick;
    const closeFunc = !_.isUndefined(closeMenu) ? closeMenu : this.handleClose;

    return (
      <div className="dropdown-container">
        <button
          type="button"
          ref={ el => this.anchorEl = el }
          onClick={ openFunc }
          className={
            classNames({
              dropdown: true,
              [className]: true,
              [`${ className }--open`]: openStatus
            })
          }
        >
          <div className={
            classNames({
              'dropdown__text': true,
              'dropdown__text--retail': isRetail
            })
          }
          >
            { value }
          </div>
          <div className={
            classNames({
              'dropdown__icon': true,
              'dropdown__icon--open': openStatus,
              'dropdown__icon--margin': iconMargin
            })
          }
          >
            <Component />
          </div>
        </button>
        <Popper
          className={
            classNames({
              popper: true,
              [popperClass]: true
            })
          }
          open={ openStatus }
          anchorEl={ this.anchorEl }
          placement={ placement }
          style={ { width: this.anchorEl?.offsetWidth } }
        >
          <ClickAwayListener onClickAway={ closeFunc }>
            <div>
              { children }
            </div>
          </ClickAwayListener>
        </Popper>
      </div>
    );
  }

}

DropDown.defaultProps = {
  disabled: false,
  children: [],
  iconMargin: false,
  className: '',
  placement: 'bottom-start',
  isRetail: false
};

DropDown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  IconComponent: PropTypes.object,
  popperClass: PropTypes.string,
  iconMargin: PropTypes.bool,
  openMenu: PropTypes.func,
  closeMenu: PropTypes.func,
  open: PropTypes.bool,
  placement: PropTypes.string,
  isRetail: PropTypes.bool
};

export default DropDown;
